import { render, staticRenderFns } from "./Capsule.vue?vue&type=template&id=82523034&"
import script from "./Capsule.vue?vue&type=script&lang=js&"
export * from "./Capsule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports